import { render, staticRenderFns } from "./suplicencelWarnList.vue?vue&type=template&id=2c8261bd"
import script from "./suplicencelWarnList.vue?vue&type=script&lang=js"
export * from "./suplicencelWarnList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports